import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { NotFound } from '../../../../vtex-apps/search-result/NotFound/default';
import { v4 as uuidv4 } from 'uuid';

export default function SearchNotFoundGroup() {
	return {
		componentName: 'SearchNotFoundLayout',
		componentId: uuidv4(),
		componentGroup: 'SearchNotFoundGroup',
		variables,
		props: {},
		childrenComponents: [
			{
				componentGroup: 'BreadcrumbGroup',
				componentName: 'Breadcrumb',
				componentId: uuidv4(),
			},
			FlexLayoutRow({ blockClass: 'search-nf-1__flex-row', horizontalAlign: 'center' }, [
				NotFound({ blockClass: 'search-nf-1__not-found' }),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--snf-1-bg', name: 'Background' },
			{ from: '--neutral-color-high-dark', to: '--snf-1-oops-text', name: 'Left Text' },
			{ from: '--text-color-1', to: '--snf-1-right-text', name: 'Right Subhead' },
			{ from: '--neutral-color-low-light', to: '--snf-1-body-text', name: 'Right Body' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-display', to: '--snf-1-oops-fs', name: 'Left Text' },
			{ from: '--font-size-sm', to: '--snf-1-right-fs', name: 'Right Subhead' },
			{ from: '--font-size-sm', to: '--snf-1-body-fs', name: 'Right Body' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--snf-1-oops-fw', name: 'Left Text' },
			{ from: '--font-weight-400', to: '--snf-1-right-fw', name: 'Right Subhead' },
			{ from: '--font-weight-400', to: '--snf-1-body-fw', name: 'Right Body' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--snf-1-oops-ff', name: 'Left Text' },
			{ from: '--main-font', to: '--snf-1-right-ff', name: 'Right Subhead' },
			{ from: '--main-font', to: '--snf-1-body-ff', name: 'Right Body' },
		],
	},
];
